/**
 * @copyright
 * Copyright (c) 2024 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import ApiCaller from "~/api/ApiCaller";
import {
  GetEmailSubscriptionResponse,
  GetPromotionSitesResponseType,
  GetReferrerSitesResponseData,
  PostEmailSubscriptionPayload,
} from "~/features/statistics/types";

const StatisticsApi = {
  getReferrerSites: () => ApiCaller.get<GetReferrerSitesResponseData>("/v1/reseller/referrer"),

  getPromotionSites: () => ApiCaller.get<GetPromotionSitesResponseType>("/v1/sitepromotion/promotions"),

  getEmailSubscription: () => ApiCaller.get<GetEmailSubscriptionResponse>("v1/reseller/subscriptioninfo"),

  postEmailSubscription: (payload: PostEmailSubscriptionPayload) =>
    ApiCaller.post("/v1/reseller/emailsubscription", payload),
};

export default StatisticsApi;
